export const compareIncluding = (first = "", second = "") =>
  first?.toUpperCase()?.includes(second?.toUpperCase());

export const keys = (object) => Object.keys(object);

export const state = (array) => JSON.parse(JSON.stringify(array));
